<!-- 天级数据 -->
<template>
<div>
	<a-drawer
		  :width="(drawer_width + 80) + 'px'"
	      placement="right"
	      :closable="false"
	      :visible="visibleData"
	      @close="drawerClose"
	    >
		<div style="height: 100%;position:relative;padding-left: 20px;">
			<div>
				<div :style="{'width': table_width + 'px'}" style="position:relative;">
					<div style="position: sticky;left:44px;display: inline-block;">
						<div style="font-size: 18px;padding: 0 0 20px 0;">天级数据</div>
						<div style="display: flex;margin-bottom: 15px;color: #333;">
							<div style="display: flex;margin-right:50px;">
								<div v-if="page_type == 'JLjh'" style="margin-rigiht:10px;">计划ID：</div>
								<div v-else-if="page_type == 'JLpromotion' || page_type == 'MPgg'" style="margin-rigiht:10px;">广告ID：</div>
								<div v-else style="margin-rigiht:10px;">ID：</div>
								<div>{{show_id}}</div>
							</div>
							<div style="display: flex;">
								<div v-if="page_type == 'JLjh'" style="margin-rigiht:10px;">计划名称：</div>
								<div v-else-if="page_type == 'JLpromotion' || page_type == 'MPgg'" style="margin-rigiht:10px;">广告名称：</div>
								<div v-else style="margin-rigiht:10px;">名称：</div>
								<div>{{show_name}}</div>
							</div>
						</div>
						
						<div style="display: flex;">
							<div class="screen-box">
								<div class="screen-label">日期</div>
								<dateRangePicker :date_width="300" :before_number="date_number"
								@onGetDate="onGetDate"></dateRangePicker>
							</div>
							
							<a-button class="screen-box" @click="searchReq()" :loading="search_button_loading" type="primary" icon="search">搜索</a-button>
							<a-button @click="custtom_visible = true" icon="unordered-list" style="">自定义列</a-button>
						</div>
					</div>
				</div>
				
				
				
				<div style="display: flex;margin-left: -44px;" :style="{'width': table_width + 'px'}">
					<div style="width: 44px;left: 0;top: 0;height: 100vh;background: #fff;z-index: 91;position: sticky;flex-shrink: 0;"></div>
					<div style="position:relative;">
						
						<!-- 表头 -->
						<div class="table-th" :style="{'width': table_width + 'px'}">
							<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
								<template v-for="(item,index) in tableTitleData" name="item.type">
									<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
									:style="{'width':tableTitleData[index].width + 'px','justify-content': item.text_right?'flex-end':'','cursor':item.sort_control?'pointer':'default',}" 
									@click="sortClick(index)">
										{{tableTitleData[index].title}}
										<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
											<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
											<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
										</div>
									</div>
								</template>
							</div>
							
							<div  v-for="(item,index) in tableTitleData" :key="index" >
								<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
								:style="{'width':item.width + 'px','justify-content': item.text_right?'flex-end':'','cursor':item.sort_control?'pointer':'default','padding-left': item.type == 'eff_count'?'20px':'8px'}" 
								@click="sortClick(index)">
									{{item.title}}
									<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
										<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
										<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
									</div>
								</div>
							</div>
						</div>
						
						<!-- 表格内容 -->
						<div v-for="(item,index) in showTableData" :key="index" class="table-td"  :style="{'width': table_width + 'px'}">
							<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
								<template v-for="(z_tem,z_ndex) in tableTitleData">
									<div v-if="z_ndex <= sticky_index" class="table-td-cell"
									:style="{'width':tableTitleData[z_ndex].width + 'px','justify-content': tableTitleData[z_ndex].text_right?'flex-end':'',}">
										{{item[z_tem.type]}} <br/>
										<template v-if="z_tem.type == 'date_key'">{{item.promote_hour}}</template>
									</div>
								</template>
							</div>
							<template v-for="(z_tem,z_ndex) in tableTitleData">
								<div v-if="z_ndex > sticky_index && z_tem.show_control && tableType.indexOf(z_tem.type) == -1" class="table-td-cell"
								:style="{'width':tableTitleData[z_ndex].width + 'px','justify-content': tableTitleData[z_ndex].text_right?'flex-end':'',}">
									{{item[z_tem.type]}}
								</div>
								<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'eff_count'" class="table-td-cell"
								:style="{'width':tableTitleData[z_ndex].width + 'px','justify-content': tableTitleData[z_ndex].text_right?'flex-end':''}" 
								style="display: flex;align-items: initial;padding-left:20px;">
								<template v-if="item.eff_count">
									
									<div>
										<div class="td-hour-z" v-if="bg_data[0].show_control">
											<div style="flex-shrink: 0;">总充值用户数：</div>
											<div>{{item[z_tem.type].eff_total_pay_user_cnt}}</div>
										</div>
										<div class="td-hour-z" v-if="bg_data[1].show_control">
											<div style="flex-shrink: 0;">总充值用户成本：</div>
											<div>{{item[z_tem.type].eff_total_pay_user_cost | tableToFixed}}</div>
										</div>
										<div class="td-hour-z" v-if="bg_data[2].show_control">
											<div style="flex-shrink: 0;">总充值金额：</div>
											<div>{{item[z_tem.type].eff_total_pay_money}}</div>
										</div>
										<div class="td-hour-z" v-if="bg_data[3].show_control">
											<div style="flex-shrink: 0;">总分成金额：</div>
											<div style="color:#2f88ff;">{{item[z_tem.type].eff_total_left_money}}</div>
										</div>
										<div class="td-hour-z" v-if="bg_data[4].show_control">
											<div style="flex-shrink: 0;">总ROI：</div>
											<div style="color:red;">{{item[z_tem.type].eff_roi | RoiToFixed}}%</div>
										</div>
										<div class="td-hour-z" v-if="bg_data[5].show_control">
											<div style="flex-shrink: 0;">总ARPU：</div>
											<div>{{item[z_tem.type].eff_total_pay_user_arpu | tableToFixed}}</div>
										</div>
									</div>
									
									<div>
										<div class="td-hour" v-if="cc_data[0].show_control">
											<div style="flex-shrink: 0;">首充用户数：</div>
											<div>{{item[z_tem.type].eff_total_pay_user_cnt_fisrt}}</div>
										</div>
										<div class="td-hour" v-if="cc_data[1].show_control">
											<div style="flex-shrink: 0;">首充用户成本：</div>
											<div>{{item[z_tem.type].eff_total_pay_user_cost_first | tableToFixed}}</div>
										</div>
										<div class="td-hour" v-if="cc_data[2].show_control">
											<div style="flex-shrink: 0;">首充总充值金额：</div>
											<div>{{item[z_tem.type].eff_total_money_fisrt}}</div>
										</div>
										<div class="td-hour" v-if="cc_data[3].show_control">
											<div style="flex-shrink: 0;">首充分成金额：</div>
											<div style="color:#2f88ff;">{{item[z_tem.type].eff_total_left_money_fisrt}}</div>
										</div>
										<div class="td-hour" v-if="cc_data[4].show_control">
											<div style="flex-shrink: 0;">首充ROI：</div>
											<div style="color:red;">{{item[z_tem.type].eff_roi_first | RoiToFixed}}%</div>
										</div>
										<div class="td-hour" v-if="cc_data[5].show_control">
											<div style="flex-shrink: 0;">首充ARPU：</div>
											<div>{{item[z_tem.type].eff_total_pay_user_arpu_first | tableToFixed}}</div>
										</div>
									</div>
									
								</template>
								</div>
								<div v-else-if="z_ndex > sticky_index && z_tem.show_control && tableType.indexOf(z_tem.type) > -1 && z_tem.type != 'eff_count'" class="table-td-cell"
								:style="{'width':tableTitleData[z_ndex].width + 'px','justify-content': tableTitleData[z_ndex].text_right?'flex-end':''}" 
								style="display: flex;align-items: initial;">
								<template v-if="item.eff">
									<template v-for="(e_tem,e_index) in item.eff">
										<template v-if="e_tem.eff_daily_span == z_tem.type">
											<div>
												<div class="td-hour-z" v-if="bg_data[0].show_control">
													<div style="flex-shrink: 0;">总充值用户数：</div>
													<div>{{e_tem.eff_total_pay_user_cnt}}</div>
												</div>
												<div class="td-hour-z" v-if="bg_data[1].show_control">
													<div style="flex-shrink: 0;">总充值用户成本：</div>
													<div>{{e_tem.eff_total_pay_user_cost | tableToFixed}}</div>
												</div>
												<div class="td-hour-z" v-if="bg_data[2].show_control">
													<div style="flex-shrink: 0;">总充值金额：</div>
													<div>{{e_tem.eff_total_pay_money}}</div>
												</div>
												<div class="td-hour-z" v-if="bg_data[3].show_control">
													<div style="flex-shrink: 0;">总分成金额：</div>
													<div style="color:#2f88ff;">{{e_tem.eff_total_left_money}}</div>
												</div>
												<div class="td-hour-z" v-if="bg_data[4].show_control">
													<div style="flex-shrink: 0;">总ROI：</div>
													<div style="color:red;">{{e_tem.eff_roi | RoiToFixed}}%</div>
												</div>
												<div class="td-hour-z" v-if="bg_data[5].show_control">
													<div style="flex-shrink: 0;">总ARPU：</div>
													<div>{{e_tem.eff_total_pay_user_arpu | tableToFixed}}</div>
												</div>
											</div>
											
											<div>
												<div class="td-hour" v-if="cc_data[0].show_control">
													<div style="flex-shrink: 0;">首充用户数：</div>
													<div>{{e_tem.eff_total_pay_user_cnt_fisrt}}</div>
												</div>
												<div class="td-hour" v-if="cc_data[1].show_control">
													<div style="flex-shrink: 0;">首充用户成本：</div>
													<div>{{e_tem.eff_total_pay_user_cost_first | tableToFixed}}</div>
												</div>
												<div class="td-hour" v-if="cc_data[2].show_control">
													<div style="flex-shrink: 0;">首充总充值金额：</div>
													<div>{{e_tem.eff_total_money_fisrt}}</div>
												</div>
												<div class="td-hour" v-if="cc_data[3].show_control">
													<div style="flex-shrink: 0;">首充分成金额：</div>
													<div style="color:#2f88ff;">{{e_tem.eff_total_left_money_fisrt}}</div>
												</div>
												<div class="td-hour" v-if="cc_data[4].show_control">
													<div style="flex-shrink: 0;">首充ROI：</div>
													<div style="color:red;">{{e_tem.eff_roi_first | RoiToFixed}}%</div>
												</div>
												<div class="td-hour" v-if="cc_data[5].show_control">
													<div style="flex-shrink: 0;">首充ARPU：</div>
													<div>{{e_tem.eff_total_pay_user_arpu_first | tableToFixed}}</div>
												</div>
											</div>
											
										</template>
										<!-- <template v-else-if="e_index == z_tem.type">空</template> -->
									</template>
								</template>
								
									
								</div>
							</template>
						</div>
						
						<!-- 表格内容为空时显示 -->
						<div v-show="showTableData.length == 0" style="text-align: center;text-align:center;padding: 80px 0 50px;"
						:style="{'width': drawer_width + 'px'}">
							<a-icon style="font-size: 70px;color: #999;" type="file-search" />
							<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
						</div>
						<!-- 分页 -->
						<pagingCompont style="margin-left: -20px;" :table_scroll_width="table_width" :table_null_width="drawer_width"
						:r_page="t_page" :r_limit="t_limit" :table_total="t_total"
						@pagination-Change="paginationConfig" @change-size-limit="changeSizeLimit"></pagingCompont>
						
						<div style="position: fixed;top: 40%;transform: translate(-50%, -50%);z-index: 95;" 
						:style="{'right': drawer_width/2 + 'px'}"
						v-show="drawer_search_loading">
							<a-spin size="large" />
						</div>
					
					</div>
				</div>
			</div>
			
		</div>
	</a-drawer>
	
	<!-- 自定义列 -->
	<a-modal v-model="custtom_visible" width="830px" title="设置自定义列" @ok="customOK" okText="确认" cancelText="取消" >
	    <div style="max-height:500px;overflow-y: overlay;">
			
			<div class="custom-title">
				<a-checkbox @change="checkboxCustom($event,1,a_custom)"
				:checked="a_custom" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
				推广数据
			</div>
			<div class="custom-cell-box">
				<template v-for="(item,index) in tableTitleData">
					<div v-if="(jc_data.indexOf(item.type) > -1)" 
					:key="item.type" style="width:240px;">
						<a-checkbox @change="onChangeSJ($event,index)"
						:checked="item.show_control" style="margin-right: 5px;margin-bottom:7px;">
							{{item.title}}
						</a-checkbox>
					</div>
				</template>
			</div>
			
			<div class="custom-title">
				<a-checkbox @change="checkboxCustom($event,2,b_custom)"
				:checked="b_custom" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
				总效果数据
			</div>
			<div class="custom-cell-box">
				<template v-for="(item,index) in bg_data">
					<div
					:key="item.type" style="width:240px;">
						<a-checkbox @change="onChangeJC($event,index)"
						:checked="item.show_control" style="margin-right: 5px;margin-bottom:7px;">
							{{item.title}}
						</a-checkbox>
					</div>
				</template>
			</div>
			
			<div class="custom-title">
				<a-checkbox @change="checkboxCustom($event,3,c_custom)"
				:checked="c_custom" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
				首充效果数据
			</div>
			<div class="custom-cell-box">
				<template v-for="(item,index) in cc_data">
					<div
					:key="item.type" style="width:240px;">
						<a-checkbox @change="onChangeCC($event,index)"
						:checked="item.show_control" style="margin-right: 5px;margin-bottom:7px;">
							{{item.title}}
						</a-checkbox>
					</div>
				</template>
			</div>
	    </div>
	</a-modal>
</div>
</template>

<script>
import { JLjhDayEff, JLpmDayEff, MPggDayEff, BDdyDayEff, WbjhDayEff } from '@/request/api'
export default {
	name: 'JLjhDay',
	props: ['show_name','show_id','page_type'],
	components: {},
	data() {
		return {
			startTime: '2022-06-12',
			endTime: '2022-06-23',
			
			search_button_loading: false,
			
			visibleData: false,
			tableTitleData: [ 
				{title:"推广日期", width:90, type:"date_key", text_right: false, show_control: true, sort_status:0,sort_control: true,},
				
				{title:"消耗金额", width:90, type:"cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"曝光", width:90, type:"show", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击", width:80, type:"click", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击率", width:80, type:"ctr", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"cpc", width:80, type:"avg_click_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"ecpm", width:90, type:"avg_show_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"激活数", width:90, type:"active", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"激活成本", width:90, type:"active_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"转化数", width:80, type:"convert", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化成本", width:90, type:"convert_cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化率", width:80, type:"convert_rate", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"总效果数据", width:190, type:"eff_count", text_right: false, show_control: true,},
				{title:"推广当天", width:190, type:"0", text_right: false, show_control: true,},
				{title:"后续第1天", width:190, type:"1", text_right: false, show_control: true,},
				{title:"后续第2天", width:190, type:"2", text_right: false, show_control: true,},
				{title:"后续第3天", width:190, type:"3", text_right: false, show_control: true,},
				{title:"后续第4天", width:190, type:"4", text_right: false, show_control: true,},
				{title:"后续第5天", width:190, type:"5", text_right: false, show_control: true,},
				{title:"后续第6天", width:190, type:"6", text_right: false, show_control: true,},
			],
			tableTitle2: [ // 广告2.0的表格
				{title:"推广日期", width:90, type:"date_key", text_right: false, show_control: true, sort_status:0,sort_control: true,},
				
				{title:"消耗金额", width:90, type:"stat_cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"曝光", width:90, type:"show_cnt", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击", width:80, type:"click_cnt", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击率", width:80, type:"ctr", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"cpc", width:80, type:"cpc_platform", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"ecpm", width:90, type:"cpm_platform", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"激活数", width:90, type:"active", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"激活成本", width:90, type:"active_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"转化数", width:80, type:"convert", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化成本", width:90, type:"conversion_cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化率", width:80, type:"conversion_rate", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"总效果数据", width:190, type:"eff_count", text_right: false, show_control: true,},
				{title:"推广当天", width:190, type:"0", text_right: false, show_control: true,},
				{title:"后续第1天", width:190, type:"1", text_right: false, show_control: true,},
				{title:"后续第2天", width:190, type:"2", text_right: false, show_control: true,},
				{title:"后续第3天", width:190, type:"3", text_right: false, show_control: true,},
				{title:"后续第4天", width:190, type:"4", text_right: false, show_control: true,},
				{title:"后续第5天", width:190, type:"5", text_right: false, show_control: true,},
				{title:"后续第6天", width:190, type:"6", text_right: false, show_control: true,},
			],
			tableTitle3: [ // ADQ、MP
				{title:"推广日期", width:90, type:"date_key", text_right: false, show_control: true, sort_status:0,sort_control: true,},
				
				{title:"消耗金额", width:90, type:"cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"曝光", width:90, type:"show", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击", width:80, type:"click", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击率", width:80, type:"ctr", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"cpc", width:80, type:"avg_click_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"ecpm", width:90, type:"avg_show_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"公众号关注数", width:80, type:"from_follow_uv", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"公众号关注成本", width:90, type:"from_follow_cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"MP关注数", width:80, type:"follow_count", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"MP关注成本", width:90, type:"follow_cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				
				{title:"转化数", width:80, type:"conversions_count", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化成本", width:90, type:"conversions_cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化率", width:80, type:"conversions_rate", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"总效果数据", width:190, type:"eff_count", text_right: false, show_control: true,},
				{title:"推广当天", width:190, type:"0", text_right: false, show_control: true,},
				{title:"后续第1天", width:190, type:"1", text_right: false, show_control: true,},
				{title:"后续第2天", width:190, type:"2", text_right: false, show_control: true,},
				{title:"后续第3天", width:190, type:"3", text_right: false, show_control: true,},
				{title:"后续第4天", width:190, type:"4", text_right: false, show_control: true,},
				{title:"后续第5天", width:190, type:"5", text_right: false, show_control: true,},
				{title:"后续第6天", width:190, type:"6", text_right: false, show_control: true,},
			],
			tableTitle4: [ // 百度看板-单元
				{title:"推广日期", width:90, type:"date_key", text_right: false, show_control: true, sort_status:0,sort_control: true,},
				
				{title:"消耗金额", width:90, type:"cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"点击", width:80, type:"click", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击率", width:80, type:"ctr", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"cpc", width:80, type:"cpc", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"cpm", width:90, type:"cpm", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"展现数", width:90, type:"impression", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"组件点击次数", width:90, type:"phoneButtonClicks", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"互动", width:90, type:"interaction", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"转化数", width:80, type:"ocpcTargetTrans", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化成本", width:90, type:"ocpcTargetTransCPC", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"转化率", width:80, type:"ocpcTargetTransRatio", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"落地页跳转量", width:90, type:"aggrFormSubmitSuccess", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"跳转成本", width:90, type:"formSubmitCost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"微信调起按钮点击量", width:90, type:"weiXinAppButtonConversions", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"微信调起按钮点击成本", width:90, type:"weiXinAppButtonConversionsCost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"微信加粉成功量", width:90, type:"weixinFollowSuccessConversions", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"微信加粉成功成本", width:90, type:"weixinFollowSuccessConversionsCost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"微信复制按钮点击量", width:90, type:"weiXinCopyConversions", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"微信复制按钮点击成本", width:90, type:"weiXinCopyConversionsCost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"总效果数据", width:190, type:"eff_count", text_right: false, show_control: true,},
				{title:"推广当天", width:190, type:"0", text_right: false, show_control: true,},
				{title:"后续第1天", width:190, type:"1", text_right: false, show_control: true,},
				{title:"后续第2天", width:190, type:"2", text_right: false, show_control: true,},
				{title:"后续第3天", width:190, type:"3", text_right: false, show_control: true,},
				{title:"后续第4天", width:190, type:"4", text_right: false, show_control: true,},
				{title:"后续第5天", width:190, type:"5", text_right: false, show_control: true,},
				{title:"后续第6天", width:190, type:"6", text_right: false, show_control: true,},
			],
			tableTitle5: [
				{title:"推广日期", width:90, type:"date_key", text_right: false, show_control: true, sort_status:0,sort_control: true,},
				
				{title:"消耗金额", width:90, type:"cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"曝光", width:90, type:"show", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击", width:80, type:"click", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"点击率", width:80, type:"ctr", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"cpc", width:80, type:"avg_click_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"ecpm", width:90, type:"avg_show_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"公众号关注数", width:90, type:"from_follow_uv", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"公众号关注成本", width:90, type:"from_follow_cost", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				{title:"微信付费数", width:80, type:"wechat_cost_uv", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"微信付费金额", width:90, type:"wechat_cost", text_right: true, show_control: true, sort_status:0,sort_control: false,},
				{title:"微信付费成本", width:80, type:"wechat_cost_avg", text_right: true, show_control: false, sort_status:0,sort_control: false,},
				
				{title:"总效果数据", width:190, type:"eff_count", text_right: false, show_control: true,},
				{title:"推广当天", width:190, type:"0", text_right: false, show_control: true,},
				{title:"后续第1天", width:190, type:"1", text_right: false, show_control: true,},
				{title:"后续第2天", width:190, type:"2", text_right: false, show_control: true,},
				{title:"后续第3天", width:190, type:"3", text_right: false, show_control: true,},
				{title:"后续第4天", width:190, type:"4", text_right: false, show_control: true,},
				{title:"后续第5天", width:190, type:"5", text_right: false, show_control: true,},
				{title:"后续第6天", width:190, type:"6", text_right: false, show_control: true,},
			],
			tableType: ["eff_count","0","1","2","3","4","5","6"],
			sticky_index: 1,
			table_width: 1000, // 表格宽度
			showTableData:[],
			t_page: 1,
			t_limit: 30,
			t_total: 0,
			
			drawer_search_loading: false,
			
			custtom_visible: false,
			
			a_custom: false,
			jc_data: ['cost','show','click','ctr','avg_click_cost','avg_show_cost','active','active_cost','convert','convert_cost','convert_rate'],
			jc_data3: ['cost','show','click','ctr','avg_click_cost','avg_show_cost','from_follow_uv','from_follow_cost','follow_count','follow_cost','conversions_count','conversions_cost','conversions_rate'],
			jc_data4: ['cost','click','ctr','cpc','cpm','impression','phoneButtonClicks','interaction','ocpcTargetTrans','ocpcTargetTransCPC','ocpcTargetTransRatio','aggrFormSubmitSuccess','formSubmitCost','weiXinAppButtonConversions','weiXinAppButtonConversionsCost','weixinFollowSuccessConversions','weixinFollowSuccessConversionsCost','weiXinCopyConversions','weiXinCopyConversionsCost'],
			jc_data5: ['cost','show','click','ctr','avg_click_cost','avg_show_cost','from_follow_uv','from_follow_cost','wechat_cost_uv','wechat_cost','wechat_cost_avg'],
			b_custom: false,
			bg_data: [
				{title: "总充值用户数",show_control: true,},
				{title: "总充值用户成本",show_control: true,},
				{title: "总充值金额",show_control: false,},
				{title: "总分成金额",show_control: true,},
				{title: "总ROI",show_control: true,},
				{title: "总ARPU",show_control: false,},
			],
			c_custom: false,
			cc_data: [
				{title: "首充用户数",show_control: false,},
				{title: "首充用户成本",show_control: false,},
				{title: "首充总充值金额",show_control: false,},
				{title: "首充分成金额",show_control: false,},
				{title: "首充ROI",show_control: false,},
				{title: "首充ARPU",show_control: false,},
			],
			
			drawer_width: 1300, // 侧边栏的宽度
			
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			date_number: 7, // 默认开始日期
			
			request_id: null,
		}
	},
	mounted(){
		// 获取当天日期
		this.endTime = this.$getThisDay()
		// 获取x天前的日期
		this.startTime = this.$getBeforeDay(this.date_number)
		
		this.drawer_width = Math.floor(document.body.clientWidth*0.8) - 80
		this.computeTableWidth()
		// console.log("page_type",this.page_type)
		if(this.page_type == "JLpromotion"){ // 巨量广告2.0的字段跟计划页的不一样
			this.tableTitleData = this.tableTitle2
		}
		else if(this.page_type == "MPgg"){ // MP、ADQ和其他的有点不一样
			this.tableTitleData = this.tableTitle3
			this.jc_data = this.jc_data3
		}
		else if(this.page_type == "BDdy"){ // 百度单元
			this.tableTitleData = this.tableTitle4
			this.jc_data = this.jc_data4
		}
		else if(this.page_type == "WBjh"){ // 微博计划
			this.tableTitleData = this.tableTitle5
			this.jc_data = this.jc_data5
		}
	},
	methods:{
		// 日期选择
		onGetDate(date_start, date_end) {
			this.startTime = date_start
			this.endTime = date_end
		},

		// 获取数据
		getTableData(req_id,type){
			console.log("this.show_id",this.show_id)
			console.log("req_id",req_id)
			let that = this
			that.request_id = req_id
			that.$emit('hour-loading-handle', true)
			this.drawer_search_loading = true
			
			if(type == 'button'){
				that.t_page = 1
			}
			
			let r_data = {
				page: that.t_page,
				limit: that.t_limit,
				
				start_promote_date: this.startTime.replace(/-/g, ''),
				end_promote_date: this.endTime.replace(/-/g, ''),
				// start_promote_date: "20221213",
				// end_promote_date: "20221220",
				
				order: "date_key",
				sort: "desc",
			}
			// 排序。
			if(that.r_sort_field){
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			
			if(this.page_type == "JLjh"){ // 计划
				// r_data.plan_id = "1751389411988515"
				r_data.plan_id = req_id
				
				JLjhDayEff(r_data).then(res=>{
					that.drawer_search_loading = false
					that.$emit('hour-loading-handle', false)
					console.log("计划-天级级数据",res)
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
						return
					}
					
					that.visibleData = true
					that.showTableData = res.data.data.data
					that.t_total = res.data.data.total
					
				})
				.catch(err=>{
					that.$emit('hour-loading-handle', false)
					that.$message.error(`错误：${err}`);
				})
			}
			else if(this.page_type == "JLpromotion"){ // 广告
				// r_data.promotion_id = "7169916290751709187"
				r_data.promotion_id = req_id
				
				JLpmDayEff(r_data).then(res=>{
					that.drawer_search_loading = false
					that.$emit('hour-loading-handle', false)
					console.log("广告-天级级数据",res)
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
						return
					}
					
					that.visibleData = true
					that.showTableData = res.data.data.data
					that.t_total = res.data.data.total
					
				})
				.catch(err=>{
					that.$emit('hour-loading-handle', false)
					that.$message.error(`错误：${err}`);
				})
			}
			else if(this.page_type == "MPgg"){
				r_data.group_id = req_id
				// r_data.group_id = "10219444002"
				MPggDayEff(r_data).then(res=>{
					that.drawer_search_loading = false
					that.$emit('hour-loading-handle', false)
					console.log("MP广告-天级数据",res)
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
						return
					}
					
					that.visibleData = true
					that.showTableData = res.data.data.data
					that.t_total = res.data.data.total
				})
				.catch(err=>{
					that.$emit('hour-loading-handle', false)
					that.$message.error(`错误：${err}`);
				})
			}
			else if(this.page_type == "BDdy"){
				r_data.adgroupFeedId = req_id
				// r_data.adgroupFeedId = "8274515463"
				BDdyDayEff(r_data).then(res=>{
					that.drawer_search_loading = false
					that.$emit('hour-loading-handle', false)
					console.log("百度单元-天级数据",res)
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
						return
					}
					
					that.visibleData = true
					that.showTableData = res.data.data.data
					that.t_total = res.data.data.total
				})
				.catch(err=>{
					that.$emit('hour-loading-handle', false)
					that.$message.error(`错误：${err}`);
				})
			}
			else if(this.page_type == "WBjh"){
				r_data.plan_id = req_id
				// r_data.plan_id = "17236824"
				WbjhDayEff(r_data).then(res=>{
					that.drawer_search_loading = false
					that.$emit('hour-loading-handle', false)
					console.log("微博计划-天级数据",res)
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
						return
					}
					
					that.visibleData = true
					that.showTableData = res.data.data.data
					that.t_total = res.data.data.total
				})
				.catch(err=>{
					that.$emit('hour-loading-handle', false)
					that.$message.error(`错误：${err}`);
				})
			}
		},
		searchReq(){
			this.t_page = 1
			this.getTableData(this.request_id)
		},
		drawerClose(){
			this.visibleData = false
			this.drawer_search_loading = false
			this.$emit('hour-drawer-close', false)
		},
		paginationConfig(e){
			// console.log("ppp",e)
			this.t_page = e
			this.getTableData(this.request_id)
		},
		changeSizeLimit(e){
			this.t_limit = e
			this.getTableData(this.request_id,'button')
		},
		
		// 计算表格宽度
		computeTableWidth(){
			let that = this
			let nn = 0
			let fff = 0
			this.tableTitleData.forEach(res=>{ 
				if(res.show_control){
					fff = fff + res.width
				}
			})
			this.table_width = fff + 24
		},
		// 自定义
		customOK(){
			this.custtom_visible = false
		},
		
		// 自定义列的小标题前的选择框
		checkboxCustom(e,type,d_tem){
			if(type == 1){
				this.a_custom = e.target.checked
				
				this.tableTitleData.forEach(res=>{
					this.jc_data.forEach(d_es=>{
						if(res.type == d_es){
							if(e.target.checked){ // 要进行选中
								res.show_control = true
							}
							else {
								res.show_control = false
							}
						}
					})
				})
				// 重新计算表格宽度
				this.computeTableWidth()
			}
			else if(type == 2){
				this.b_custom = e.target.checked
				this.bg_data.forEach(res=>{
					if(e.target.checked){ // 要进行选中
						res.show_control = true
					}
					else {
						res.show_control = false
					}
				})
				this.computOptionWidth()
			}
			else if(type == 3){
				this.c_custom = e.target.checked
				this.cc_data.forEach(res=>{
					if(e.target.checked){ // 要进行选中
						res.show_control = true
					}
					else {
						res.show_control = false
					}
				})
				this.computOptionWidth()
			}
			
		},
		// 重新计算小时级数据表格项的宽度
		computOptionWidth(){
			let that = this
			let b_control = true
			that.bg_data.forEach(res=>{
				if(res.show_control){ // 只要有一个项是要显示的
					b_control = false
				}
			})
			
			let c_control = true
			that.cc_data.forEach(res=>{
				if(res.show_control){ // 只要有一个项是要显示的
					c_control = false
				}
			})
			
			let www = 190
			if(!b_control && !c_control){
				www = 350
			}
			
			that.tableTitleData.forEach(res=>{
				that.tableType.forEach(t_es=>{
					if(res.type == t_es){
						res.width = www
					}
				})
			})
			
			// 重新计算表格宽度
			this.computeTableWidth()
		},
		// 自定义列下级选择框
		onChangeSJ(e,index){
			this.tableTitleData[index].show_control = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
			// 重新计算表格宽度
			this.computeTableWidth()
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			this.jc_data.forEach(res=>{
				this.tableTitleData.forEach(t_es=>{
					if(res == t_es.type && !t_es.show_control){ // 表示有勾选
						ccccc = false
					}
				})
			})
			this.a_custom = ccccc
		},
		onChangeJC(e,index){
			this.bg_data[index].show_control = e.target.checked
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			this.bg_data.forEach(res=>{
				if(!res.show_control){ // 表示有勾选
					ccccc = false
				}
			})
			this.b_custom = ccccc
			this.computOptionWidth()
		},
		onChangeCC(e,index){
			this.cc_data[index].show_control = e.target.checked
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			this.cc_data.forEach(res=>{
				if(!res.show_control){ // 表示有勾选
					ccccc = false
				}
			})
			this.c_custom = ccccc
			this.computOptionWidth()
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.getTableData(that.request_id)
		},
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.tableTitleData[index].type)
			if(that.tableTitleData[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.tableTitleData.forEach(res=>{
						res.sort_status = 0
					})
					that.tableTitleData[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.tableTitleData[index].sort_status === 0){
						that.tableTitleData[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.tableTitleData[index].sort_status === 1){
						that.tableTitleData[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.tableTitleData[index].sort_status === 2){
						that.tableTitleData[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				that.tableThClick(index, th_status, that.tableTitleData[index].type)
				// this.$emit('table-th-click', index, th_status, that.tableTitleData[index].type)
			}
		},
	},
	filters: {
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		},
		// 因为要百分比显示，所以×100
		RoiToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				let n = v*100 
				return n.toFixed(2)
			}
			else {
				return 0
			}
			
		}
	}
}
</script>

<style scoped>
.table-th{
	top: 0;
	align-items: initial;
}
.table-td {
	align-items: initial;
}
.table-td-cell {
	display: flex;
	align-items: center;
	font-size:12px;
}
.table-th-cell-sticky {
	left: 44px;
}
.table-td-cell-sticky {
	left: 44px;
}
/* 当表头有排序功能时加上这两个参数 */
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}
.table-th-cell {
	height: 100%;
}

.td-hour-z {
	width:160px;
}
.td-hour {
	width:160px;
}
.td-hour-z,
.td-hour {
	display: flex;
	margin-bottom: 5px;
}


.custom-title {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.custom-cell-box {
	display:flex;
	flex-wrap: wrap;
	padding-left: 20px;
	margin-bottom:20px;
}
</style>